import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { matchPath } from "react-router-dom";
import { Navbar, NavDropdown, Nav, MenuItem } from "react-bootstrap";
import PubSub from "./services/pubsub-service";
import * as PubSubActionType from "./constants/pubus-action-type";
import { AppSettings } from "./constants";
import Avatar from "./components/avatar";
import * as AuthActionType from "./Auth/constants";
import { GET_CUSTOM_TERMS } from "./Setting/constants";
import home_hub_logo from "assets/img/LOGO.png";
import HomeOwnerSpinner from "./components/HomeOwnerSpinner/loader";
import authenticator from "./Auth/authenticator";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

class Header extends Component {
  static propTypes = {
    history: PropTypes.object,
    user: PropTypes.object,
    tenantProfile: PropTypes.object,
    dispatch: PropTypes.func,
    routes: PropTypes.any,
    location: PropTypes.object,
    lotProfile: PropTypes.object,
    izendaStore: PropTypes.object,
    hobrand: PropTypes.array,
    HomeownerLots: PropTypes.array,
  };
  constructor(props) {
    super(props);

    this.state = {
      displayName: AppSettings.DISPLAY_NAME,
      avatar: AppSettings.DEFAULT_AVATAR,
      sidebarOpen: false,
      tenantProfile: {},
      pageLoadAfterAPI: false,
      navIconUpdate: false,
    };
  }

  componentWillMount() {
    this.handleMinimizeSidebar();
  }

  componentDidMount() {
    this.setState({ pageLoadAfterAPI: true, navIconUpdate: true });
    if (localStorage[AppSettings.S1_TOKEN]) {
      this.props.dispatch({
        type: AuthActionType.GET_CURRENT_USER_ASYNC,
        params: null,
        callback: (status, data) => {
          localStorage.setItem(AppSettings.S1_ROLE_NAME, data.roleName);
          if (AppSettings.clientTypeValue === "Homeowner") {
            this.props.dispatch({
              type: AuthActionType.SET_HO_BRANDING_LOGO_COLOR,
              params: {
                token: localStorage[AppSettings.S1_TOKEN],
                email: this.props.user.email,
              },
              callback: (data) => {
                if (data.length > 0) {
                  var customStyleJson = JSON.parse(data[0].customStyleJson);
                  var primaryPalette = customStyleJson
                    ? customStyleJson.PrimaryPalette
                    : "#4267b2";
                  var secondaryPalette = customStyleJson
                    ? customStyleJson.SecondaryPalette
                    : "#f06424";
                  document.body.style.setProperty(
                    "--primary-color",
                    primaryPalette
                  );

                  document.body.style.setProperty(
                    "--secondary-color",
                    secondaryPalette
                  );
                  // const elementValue = window.getComputedStyle(elem, null);
                  // const rgbObj = elementValue.getPropertyCSSValue("color").getRGBColorValue();
                  // console.log("elementValue", elementValue)
                  // console.log("rgbObj", rgbObj)
                  // #C5C5C5
                  if (document.body.style[0] == "--primary-color") {
                    this.setState({
                      pageLoadAfterAPI: false,
                      navIconUpdate: false,
                    });
                  }
                } else {
                  document.body.style.setProperty("--primary-color", "#4267b2");

                  document.body.style.setProperty(
                    "--secondary-color",
                    "#f06424"
                  );
                  this.setState({
                    pageLoadAfterAPI: false,
                    navIconUpdate: false,
                  });
                }
                // else if(
                //   this.props.lotProfile &&
                //   this.props.lotProfile.clientInfo &&
                //   data.length > 0
                // ){
                //   console.log("Header Lot detail")
                //   data.map(hobrand =>
                //     {

                //       if(hobrand.builderId.replace('www.','') === this.props.lotProfile.clientInfo.domain.replace('http://','')){
                //         document.body.style.setProperty(
                //     '--primary-color',
                //     hobrand.PrimaryPalette
                //   );

                //   document.body.style.setProperty(
                //     '--secondary-color',
                //     hobrand.SecondaryPalette
                //   );
                //   }
                //   else{
                //     console.log("Header no Lot list and no lot detail")
                //     document.body.style.setProperty(
                //       '--primary-color',
                //       '#4267b2'
                //     );

                //     document.body.style.setProperty(
                //       '--secondary-color',
                //       '#f06424'
                //     );
                //   }

                // }
                //   );
                // }
              },
            });
          }
        },
      });

      // if (
      //   AppSettings.clientTypeValue === 'Builder' ||
      //   AppSettings.clientTypeValue === 'System'
      // ) {
      //   this.props.dispatch({
      //     type: AuthActionType.GET_IZENDA_TOKEN_ASYNC
      //   });
      // }

      if (AppSettings.clientTypeValue === "Builder") {
        this.setState({ pageLoadAfterAPI: false, navIconUpdate: false });
      }
    } else {
      // this.props.history.push('/logout');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user && nextProps.user.userId) {
      this.setState({
        displayName: nextProps.user.firstName + " " + nextProps.user.lastName,
      });
    }

    if (nextProps.tenantProfile) {
      this.setState({
        tenantProfile: nextProps.tenantProfile,
      });
    }
  }

  componentWillUnmount() {
    PubSub.subscribe(PubSubActionType.UPDATE_DISPLAYNAME_AND_AVATAR);
  }

  checkRouteToDisplayLotHeader = () => {
    let match;
    if (this.props.routes !== undefined) {
      for (let i = 0; i < this.props.routes.length; i++) {
        match = matchPath(this.props.location.pathname, {
          path: this.props.routes[i].path,
          exact: true,
          sensitive: this.props.routes[i].component.sensitive,
        });
        if (
          match &&
          this.props.routes[i] &&
          this.props.routes[i].path !== "/" &&
          this.props.routes[i].path !== "/lots" &&
          this.props.routes[i].path !== "/home-hub" &&
          this.props.routes[i].path !== "/my-profile" &&
          this.props.routes[i].path !== "/documents" &&
          this.props.routes[i].path !== "/inventory"
        ) {
          return true;
        }
      }
    }
    return false;
  };

  renderLogo() {
    let data = this.props.hobrand;
    if (AppSettings.clientTypeValue === "Homeowner") {
      // for (let i = 0; i < this.props.routes.length; i++) {
      if (data && data.length > 0) {
        var hologo = data.length > 0 && data[0].hoLogoUrl;
        var customStyleJson = JSON.parse(data[0].customStyleJson);
        var primaryPalette = customStyleJson
          ? customStyleJson.PrimaryPalette
          : "#4267b2";
        var secondaryPalette = customStyleJson
          ? customStyleJson.SecondaryPalette
          : "#f06424";
        document.body.style.setProperty("--primary-color", primaryPalette);

        document.body.style.setProperty("--secondary-color", secondaryPalette);
        if (hologo) {
          return <img className="logo" src={hologo} />;
        } else {
          return (
            <img
              className="logo"
              src={this.props.user.logoUrl || AppSettings.LOGO_30}
            />
          );
        }
      }
      // else if(
      //     this.props.lotProfile &&
      //     this.props.lotProfile.clientInfo &&
      //     data.length > 0 &&
      //     this.props.routes[i].path === '/lots/:lotId'
      //   ){
      //     return data.map(hobrand =>
      //       {
      //         if(hobrand.builderId && hobrand.builderId.replace('www.','') ===
      //         this.props.lotProfile.clientInfo.domain.replace('http://','')){
      //           document.body.style.setProperty(
      //             '--primary-color',
      //             hobrand.customStyleJson?JSON.parse(hobrand.customStyleJson).PrimaryPalette:
      //             '#4267b2'
      //           );

      //           document.body.style.setProperty(
      //             '--secondary-color',
      //             hobrand.customStyleJson?JSON.parse(hobrand.customStyleJson).SecondaryPalette:
      //             '#f06424'
      //           );
      //         if(hobrand.hoLogoUrl){
      //         return (<img
      //           className='logo'
      //           src={hobrand.hoLogoUrl}
      //         />)
      //         }else{
      //           return ( <img
      //             className='logo'
      //             src={this.props.user.logoUrl || AppSettings.LOGO_30}
      //           />);
      //         }
      //     }
      //     // else{
      //     //   console.log('Header logo url not match');
      //     //   document.body.style.setProperty(
      //     //     '--primary-color',
      //     //     '#4267b2'
      //     //   );

      //     //   document.body.style.setProperty(
      //     //     '--secondary-color',
      //     //     '#f06424'
      //     //   );
      //     //   return ( <img
      //     //     className='logo'
      //     //     src={this.props.user.logoUrl || AppSettings.LOGO_30}
      //     //   />);
      //     //   // return (<div className='text-logo'>
      //     //   // {this.props.lotProfile.clientInfo.clientName}
      //     //   // </div>)
      //     // }

      //   }
      //     );
      //   }
      else {
        console.log("last else");
        document.body.style.setProperty("--primary-color", "#4267b2");

        document.body.style.setProperty("--secondary-color", "#f06424");
        if (AppSettings.LOGO_30 !== "" && AppSettings.LOGO_30 !== null) {
          return (
            <img
              className="logo"
              src={this.props.user.logoUrl || AppSettings.LOGO_30}
            />
          );
        } else {
          return <div className="text-logo">{AppSettings.COMPANY_NAME}</div>;
        }
      }
      // }
    } else {
      if (AppSettings.LOGO_30 !== "" && AppSettings.LOGO_30 !== null) {
        return (
          <img
            className="logo"
            src={this.props.user.logoUrl || AppSettings.LOGO_30}
          />
        );
      } else {
        return <div className="text-logo">{AppSettings.COMPANY_NAME}</div>;
      }
    }
  }

  renderLotHeader() {
    return (
      <div className="lot-header">
        <span className="lot-name">
          {this.props.lotProfile
            ? this.props.lotProfile.name || this.props.lotProfile.streetAddress
              ? `${this.props.lotProfile.name} - ${this.props.lotProfile.streetAddress}`
              : null
            : null}
        </span>
        <br />
        <span>
          {this.props.lotProfile ? this.props.lotProfile.location : null}
        </span>
      </div>
    );
  }

  // function that makes the sidebar from normal to mini and vice-versa
  handleMinimizeSidebar() {
    document.body.classList.toggle("sidebar-mini");
  }
  // function for responsive that hides/shows the sidebar
  mobileSidebarToggle() {
    document.documentElement.classList.toggle("nav-open");
  }

  headingTitle() {
    const pathname = this.props.location.pathname;

    if (pathname === "/my-profile") {
      return "Profile";
    } else if (pathname === "/") {
      return "Hi " + this.props.user.firstName;
    } else if (pathname === "/property") {
      return "Properties";
    } else if (pathname === "/documents") {
      return "Documents";
    } else if (pathname === "/inventory") {
      return "Inventory";
    } else if (pathname === "/home-maintenance") {
      return "Maintenance";
    } else if (pathname === "/home-care") {
      return "Home Care";
    } else {
      return "Hi " + this.props.user.firstName;
    }
  }

  onGetHomePath = () => {
    // const { izendaStore } = this.props;

    let homePath = "/";

    // if (
    //   AppSettings.clientTypeValue === 'Builder' &&
    //   izendaStore.Dashboards &&
    //   izendaStore.Dashboards.data &&
    //   izendaStore.Dashboards.data.length
    // ) {
    //   const dashboardId =
    //     izendaStore.Dashboards.data[0].subCategories[0].subCategories[0]
    //       .dashboards[0].id;

    //   homePath = `/report-dashboards#?source=/report-dashboard/edit/${dashboardId}`;
    // }

    return homePath;
  };

  redirectToClientHome = (homePath) => {
    const isExternalSSOUser = localStorage.getItem(AppSettings.IS_SSO_USER);
    if (isExternalSSOUser === "True" || isExternalSSOUser === true) {
      if (AppSettings.clientTypeValue === "Homeowner") {
        this.props.dispatch({
          type: AuthActionType.LOGOUT,
          params: null,
          callback: () => {
            this.clientUrl(homePath);
          },
        });
      } else {
        return (window.location.href = homePath);
      }
    } else {
      return (window.location.href = homePath);
    }
  };

  clientUrl = (homePath) => {
    let ssoClientRedirectUrl =
      localStorage[AppSettings.S1_REDIRECT_CLIENT_LOGIN_URL];
    // let ssoClientRedirectUrl  = "www.perryhomes.com/my-account/my-perry-home";
    if (
      ssoClientRedirectUrl !== "" &&
      ssoClientRedirectUrl !== null &&
      ssoClientRedirectUrl !== undefined
    ) {
      let pattern = /^((http|https):\/\/)/;
      if (!pattern.test(ssoClientRedirectUrl)) {
        ssoClientRedirectUrl = `${window.location.protocol}//${ssoClientRedirectUrl}`;
      }
      // authenticator.logOut();
      window.open(ssoClientRedirectUrl, "_blank", "noreferrer");
    } else {
      return (window.location.href = homePath);
    }
  };

  render() {
    const homePath = this.onGetHomePath();

    return [
      AppSettings.clientTypeValue === "Homeowner" ? (
        <Navbar fluid key="navbar">
          {/* <div className="navbar-minimize">
            {this.state.navIconUpdate ? (
              ""
            ) : (
              <button
                id="minimizeSidebar"
                className="btn btn-default btn-fill btn-round btn-icon"
                onClick={this.handleMinimizeSidebar}
              >
                <i className="fa fa-ellipsis-v visible-on-sidebar-regular" />
                <i className="fa fa-navicon visible-on-sidebar-mini" />
              </button>
            )}
          </div> */}
          {AppSettings.clientTypeValue === "Homeowner" &&
          this.state.pageLoadAfterAPI ? (
            <HomeOwnerSpinner />
          ) : (
            ""
          )}
          <Navbar.Header>
            <Navbar.Brand>
              {/* Here we create navbar brand, based on route name */}
              <div
                className="inner-navbar-brand logo-header"
                style={{
                  cursor: "pointer",
                  padding: "10px 38px 0 0",
                  marginLeft: "0px",
                  marginBottom: "0px",
                  paddingBottom: "0px",
                }}
                onClick={() => {
                  // this.props.history.push(homePath);
                  this.redirectToClientHome(homePath);
                }}
              >
                {AppSettings.clientTypeValue === "Homeowner"
                  ? this.state.pageLoadAfterAPI === false
                    ? this.renderLogo()
                    : ""
                  : this.renderLogo()}
              </div>
            </Navbar.Brand>
            <br />
            <Navbar.Brand>
              <p
                style={{
                  color: "#1C2B49",
                  fontSize: "25px",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                  padding: "15px 23px 40px 23px",
                  fontFamily: "sans-serif",
                }}
              >
                {this.headingTitle()}
              </p>
              {/* {this.props.user.firstName + " " + this.props.user.lastName} */}
            </Navbar.Brand>
            <Navbar.Toggle onClick={this.mobileSidebarToggle} />
          </Navbar.Header>
          <Navbar.Form pullLeft className="navbar-search-form" />
        </Navbar>
      ) : (
        <Navbar fluid key="navbar">
          <div className="navbar-minimize">
            {this.state.navIconUpdate ? (
              ""
            ) : (
              <button
                id="minimizeSidebar"
                className="btn btn-default btn-fill btn-round btn-icon"
                onClick={this.handleMinimizeSidebar}
              >
                <i className="fa fa-ellipsis-v visible-on-sidebar-regular" />
                <i className="fa fa-navicon visible-on-sidebar-mini" />
              </button>
            )}
          </div>
          {AppSettings.clientTypeValue === "Homeowner" &&
          this.state.pageLoadAfterAPI ? (
            <HomeOwnerSpinner />
          ) : (
            ""
          )}
          <Navbar.Header>
            <Navbar.Brand>
              {/* Here we create navbar brand, based on route name */}
              <div
                className="inner-navbar-brand logo-header"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // this.props.history.push(homePath);
                  this.redirectToClientHome(homePath);
                }}
              >
                {AppSettings.clientTypeValue === "Homeowner"
                  ? this.state.pageLoadAfterAPI === false
                    ? this.renderLogo()
                    : ""
                  : this.renderLogo()}
              </div>
            </Navbar.Brand>
            <Navbar.Toggle onClick={this.mobileSidebarToggle} />
          </Navbar.Header>

          <Navbar.Form pullLeft className="navbar-search-form" />

          <Nav pullRight style={{ marginRight: 15 }}>
            <div>
              {AppSettings.clientTypeValue === "Homeowner" &&
                this.checkRouteToDisplayLotHeader() && (
                  <Nav className="navbar-lot">{this.renderLotHeader()}</Nav>
                )}
              <Nav pullRight>
                <NavDropdown
                  eventKey={4}
                  title={
                    <span className="profile">
                      <Avatar src={null} size={32} />
                      {AppSettings.clientTypeValue === "Homeowner" &&
                        "Welcome "}
                      {this.props.user.firstName +
                        " " +
                        this.props.user.lastName}
                    </span>
                  }
                  noCaret
                  id="basic-nav-dropdown-3"
                  bsClass="dropdown-with-icons dropdown"
                  className="dropdown-profile"
                >
                  {this.props.user.sso && (
                    <MenuItem
                      eventKey={4.4}
                      onClick={() => {
                        window.location.href = AppSettings.SITE_ONE_SERVICE_URI;
                      }}
                    >
                      <i className="pe-7s-back-2" /> Go back to system site
                    </MenuItem>
                  )}
                  <MenuItem
                    eventKey={4.4}
                    onClick={() => {
                      if (!this.props.user.sso) {
                        this.props.history.push("/my-profile");
                      }
                    }}
                    disabled={this.props.user.sso}
                  >
                    <i className="pe-7s-user" /> My account
                  </MenuItem>
                  <MenuItem
                    eventKey={4.5}
                    onClick={() => {
                      this.props.history.push("/logout?action=true");
                    }}
                  >
                    <div className="text-danger">
                      <i className="pe-7s-close-circle" /> Log out
                    </div>
                  </MenuItem>
                </NavDropdown>
              </Nav>
            </div>
          </Nav>
        </Navbar>
      ),
    ];
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.UserStore.UserProfile,
    tenantProfile: state.authReducer.tenantProfile,
    lotProfile: state.LotStore.LotProfile,
    izendaStore: state.IzendaStore,
    hobrand: state.authReducer.hobrand,
    HomeownerLots: state.LotStore.HomeownerLots,
  };
};

// export default connect(mapStateToProps)(Header);
export default withRouter(connect(mapStateToProps)(Header));



// WEBPACK FOOTER //
// ./src/header.js